/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {View} from 'react-native';
import {frequenceOptions} from '../../../../../../data/constants/Assurance/assuranceRetraite';
import {dataOption} from '../../../../../../data/types/interface/input';
import {buttonsStyles} from '../../../../../components/Button/boutonStyle';
import PrimaryButton from '../../../../../components/Button/PrimaryButton';
import {DateTimePickerWeb} from '../../../../../components/Inputs/DateTimePicker/index.web';
import Input from '../../../../../components/Inputs/Input';
import Select from '../../../../../components/Inputs/Select/index.web';

const aList: dataOption[] = frequenceOptions;
export default function FormCapitalWeb({
  callBack,
  submit,
  defaultValue,
  requiredFields,
  isSubmited,
}: any) {
  React.useEffect(() => {}, [defaultValue]);

  return (
    <View>
      <DateTimePickerWeb
        defaultValue={defaultValue.DateNaissance}
        label="Date de naissance"
        callBack={(data: any) => {
          callBack('DateNaissance', data);
        }}
        requiredField={requiredFields.DateNaissance}
        minAge={18}
        required
      />
      <Input
        defaultValue={defaultValue.Capital}
        label="Le Capital Retraitre souhaité (Ar)"
        name="Capital"
        parentCallback={(data: any) => callBack('Capital', data)}
        required
        type="numeric"
        requiredField={requiredFields.Capital}
        isSubmited={isSubmited}
      />
      <Select
        data={aList}
        label="Mode de versement de la cotisation"
        value={defaultValue.ModeVersement}
        required={true}
        onChange={(name: string, data: any) => {
          callBack('ModeVersement', data);
        }}
      />
      <View style={buttonsStyles.displayCenter}>
        <View style={buttonsStyles.displayHorizontal}>
          <PrimaryButton
            onPress={() => submit(false, 'Capital')}
            styleBtnTxt={buttonsStyles.btnAnnuler}
            styleBtnOuter={buttonsStyles.btnAnnulerOuter}
            title="Annuler"
            type="annuler"
          />
          <PrimaryButton
            onPress={() => submit(true, 'Capital')}
            styleBtnTxt={buttonsStyles.btnValider}
            styleBtnOuter={buttonsStyles.btnValiderOuter}
            title="Valider"
            type="valider"
          />
        </View>
      </View>
    </View>
  );
}
